import { DestinationReduced } from "../../destination/objects/destinationReduced";

export const SET_DESTINATIONS = 'DESTINATION_TREE_SET_DESTINATIONS';
export const SET_EDIT_TREE = 'DESTINATION_TREE_EDIT_TREE';

interface SetDestinationsAction {
    type: typeof SET_DESTINATIONS,
    payload: DestinationReduced[]
}
interface SetEditTreeAction {
    type: typeof SET_EDIT_TREE,
    payload: boolean
}


export type DestinationTreeActionTypes =
    SetDestinationsAction | SetEditTreeAction;